import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { useFormOptions } from '../../../config/constants';
import { formatearFechaCorta } from '../../../utils/utils';
import React, { useState, useMemo } from 'react'
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

const ModuloEntregas = ({servicio , isAdmin = false}) => {

  const [formEntrega, setFormEntrega] = useState({
    motivo: "",
    descripcion: "",
    fechaentrega: new Date(),
    motivoEntrega: "",
  });
  const {tipoEventosParcialesOptions} = useFormOptions();
  const {addEntregaParcial,deleteEntregaParcial} = useContabilidadModel();
  const navigate = useNavigate();

  //entregas Agrupadas
  const entregasAgrupadas = useMemo(() => {
        const grupos = { avances: [], correcciones: [], adicional: [] };
        if (Array.isArray(servicio?.entregasTrabajo)) {
            servicio.entregasTrabajo.forEach(entrega => {
                if (entrega.motivoEntrega === 'AVANCE') grupos.avances.push(entrega);
                else if (entrega.motivoEntrega === 'CORRECION') grupos.correcciones.push(entrega);
                else if (entrega.motivoEntrega === 'ADICIONAL') grupos.adicional.push(entrega);
                else if (entrega.motivoEntrega === 'REVISION') grupos.adicional.push(entrega);
            });
        }
        return grupos;
    }, [servicio?.entregasTrabajo]);

  const handleRegistrarEntregaParcial = async() =>{
    await addEntregaParcial(formEntrega,servicio.nombreEmpresa,servicio.codigo);
    resetFormulario();
  };

  const handleEliminarAvance = async(idEntrega) =>{
    deleteEntregaParcial(idEntrega,servicio.nombreEmpresa,servicio.codigo);
  };

  const resetFormulario = () => {
    setFormEntrega({
      motivo: "",
      descripcion: "",
      fechaentrega: new Date(),
      motivoEntrega: "",
    });
  }

  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormEntrega({
      ...formEntrega,
      [name]: selectedOption ? selectedOption.value : ''
    });

  };

  const StatusBadge = ({ isEntregado }) => {
  if (isEntregado) {
    return (
      <span className="px-3 py-1 text-xs font-semibold text-green-800 bg-green-200 rounded-full">
        Entregado
      </span>
    );
  }
  return (
    <span className="px-3 py-1 text-xs font-semibold text-yellow-800 bg-yellow-200 rounded-full">
      Pendiente
    </span>
  );
  };
  const CardEntrega = ({ entrega, formatearFecha}) => {
    // 1. Determinar el estado de la entrega.
    // Asumimos que getTrabajoEntregado() devuelve un objeto si hay entrega, y null o undefined si no.
    const trabajoEntregado = entrega.getTrabajoEntregado();
    const isEntregado = !!trabajoEntregado; // Convierte el resultado a un booleano (true/false)

    // 2. Definir clases dinámicas para el contenedor principal.
    // Usamos un borde izquierdo de color para un feedback sutil pero efectivo.
    const cardContainerClasses = `bg-white p-4 rounded-lg shadow-sm transition hover:shadow-md border-l-4 ${
      isEntregado ? 'border-green-500' : 'border-yellow-500'
    }`;
    
    // 3. Definir clases dinámicas y texto para el botón de acción.
    const buttonClasses = `text-sm font-medium px-4 py-2 rounded-lg transition-colors duration-200 ${
      isEntregado 
        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' // Estilo para "Ver Entrega"
        : 'bg-blue-600 text-white hover:bg-blue-700'   // Estilo para "Realizar Entrega"
    }`;

    return (
      <div className={cardContainerClasses}>
        {/* Encabezado de la tarjeta */}
        <div className="flex flex-wrap justify-between items-center mb-3 gap-2">
          <span className="font-bold text-lg text-gray-800">ID: {entrega.id}</span>
          <StatusBadge isEntregado={isEntregado} />
        </div>

        {/* Información de la entrega */}
        <div className="space-y-2 text-gray-700 mb-4">
          <p><span className="font-semibold">Fecha Límite:</span> {formatearFecha(entrega.fechaentrega)}</p>
          <p><span className="font-semibold">Motivo:</span> {entrega.motivo}</p>
          {/* Puedes mostrar más detalles si lo necesitas */}
          {/* <p>{entrega.motivoEntrega}</p>
          <p>{entrega.linkEntregaTutor}</p>
          <p>{entrega.descripcion}</p>
          */}
        </div>
        
        {/* Pie de la tarjeta con la acción principal */}
        <div className="mt-4 pt-4 border-t border-gray-200 flex justify-between items-center">
          <div>
            {isEntregado ? (
              <p className="text-sm font-medium text-green-700">¡Ya has completado esta entrega!</p>
            ) : (
              <p className="text-sm font-medium text-yellow-700">Aún tienes esta entrega pendiente.</p>
            )}
          </div>
          
          <button 
            onClick={() => redireccionEntregaParcial(entrega.id)}
            className={buttonClasses}
          >
            {isEntregado ? 'Ver Entrega' : 'Realizar Entrega'}
          </button>
        </div>


        Eliminar avance
        <button
          onClick={() => 
          handleEliminarAvance(entrega.id)
        }
          className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-xs font-medium"
        >
         Eliminar Avance
         
        </button>

      </div>
    );
  };


  const handleRegresar = () => {
      //navigate(-1);
  };

  //redireccion a entrega parcial
  const redireccionEntregaParcial = (entregaId) =>{
    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}/entregasParciales/${entregaId}`);
  };

  return (
    // Contenedor principal que crea las 2 columnas en pantallas grandes (lg)
    // y las apila en pantallas pequeñas (móviles).
   <div className={isAdmin ? "lg:grid lg:grid-cols-5 lg:gap-8" : ""}>

      {/* --- COLUMNA IZQUIERDA: FORMULARIO --- */}
      {isAdmin && (
        <div className="lg:col-span-2 mb-8 lg:mb-0">
        <div className="bg-white p-6 rounded-lg shadow-md sticky top-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Registrar Entrega</h2>
          
          <form 
            onSubmit={(e) => {
              e.preventDefault(); // Evita que la página se recargue
              handleRegistrarEntregaParcial();
            }}
            className="space-y-5"
          >

             <div>
              <label htmlFor="motivo" className="block text-sm font-medium text-gray-700 mb-1">
                Motivo
              </label>
              <Select
                name="motivoEntrega"
                value={getOptionFromValue(tipoEventosParcialesOptions, formEntrega.motivoEntrega)}
                onChange={handleSelectChange}
                options={tipoEventosParcialesOptions}
                placeholder="Motivo de entrega"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
              />
            </div>


            {/* Motivo */}
            <div>
              <label htmlFor="motivo" className="block text-sm font-medium text-gray-700 mb-1">
                Título / Evento
              </label>
              <input
                id="motivo"
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Ej: Entrega Avance Capítulo 1"
                value={formEntrega.motivo || ''}
                onChange={(e) => setFormEntrega({ ...formEntrega, motivo: e.target.value })}
                required
              />
            </div>

            <div>
              <label htmlFor="descripcion" className="block text-sm font-medium text-gray-700 mb-1">
                Descripción
              </label>
              <textarea
                id="descripcion"
                rows="4"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Detalles de la entrega..."
                value={formEntrega.descripcion || ''}
                onChange={(e) => setFormEntrega({ ...formEntrega, descripcion: e.target.value })}
                required
              ></textarea>
            </div>

            <div>
              <label htmlFor="fechaentrega" className="block text-sm font-medium text-gray-700 mb-1">
                Fecha de Entrega *
              </label>
              <input
                id="fechaentrega"
                type="datetime-local"
                value={formEntrega.fechaentrega}
                onChange={(e) => setFormEntrega({ ...formEntrega, fechaentrega: e.target.value })}
                min={new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().slice(0, 16)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
              disabled={!formEntrega.motivo || !formEntrega.descripcion || !formEntrega.fechaentrega}
            >
              Registrar Entrega
            </button>
          </form>
        </div>
      </div>
      )}
    
      {/* --- COLUMNA DERECHA: HISTORIAL --- */}
      <div className="lg:col-span-3">
         <div className="space-y-6">
            {Object.entries(entregasAgrupadas).map(([tipo, lista]) => (
                <div key={tipo}>
                    <h2 className="text-xl font-bold text-blue-700 border-b-2 border-blue-200 pb-2 mb-4 capitalize">{tipo}</h2>
                    {lista.length > 0 ? (
                        <div className="space-y-4">
                            {lista.map(entrega => (
                              <CardEntrega 
                                key={entrega.id} 
                                entrega={entrega} 
                                formatearFecha={formatearFechaCorta} 
                              />
                            ))}
                        </div>
                    ) : <p className="text-gray-500 italic px-2">No se encuentran elementos</p>}
                </div>
            ))}
        </div>
      </div>

    </div>
  );

}

export default ModuloEntregas
